export default __webpack_public_path__ + "static/media/img1.c82a43fb.svg";